module.exports = __webpack_public_path__ + "img/youtube-pos.60a0b27f.jpeg";